import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDTypography from "../../components/MDTypography";
import {saveInventoryTypeSortOrders, saveTaskList} from "../common/api/InventoryApi";

export default function SortInventoryTypes(props) {
  const [context, setContext] = useContext(AppContext);
  const [inventoryTypes, setInventoryTypes] = useState({});
  const [formInvalid, setFormInvalid] = useState(false);
  const [renderIndex, setRenderIndex] = useState(1);

  useEffect(() => {
    let _types = {
      items : props?.inventoryTypes
    }
    setInventoryTypes(_types);
  }, [props?.inventoryTypes]);


  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(inventoryTypes)
  });

  const handleClose = () => {
    props.handleClose();
  };

  const handleSave = async (data) => {
    let result = await saveInventoryTypeSortOrders(data);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      props.handleSave(result);
    }
  };

  const moveUp = (item) => {
    let _obj = {...inventoryTypes};
    for (let i = 0; i < _obj.items.length; i++) {
      _obj.items[i].sortOrder = i;
    }
    for (let i = 0; i < _obj.items.length; i++) {
      if (_obj.items[i].id === item.id) {
        _obj.items[i].sortOrder = _obj.items[i].sortOrder - 1;
      } else {
        _obj.items[i].sortOrder = _obj.items[i].sortOrder + 1;
      }
    }
    setInventoryTypes({..._obj});
    setRenderIndex(renderIndex + 1);
  }

  const moveDown = (item) => {
    let _obj = {...inventoryTypes};
    for (let i = 0; i < _obj.items.length; i++) {
      _obj.items[i].sortOrder = i;
    }
    for (let i = 0; i < _obj.items.length; i++) {
      if (_obj.items[i].id === item.id) {
        _obj.items[i].sortOrder = _obj.items[i].sortOrder + 1;
      } else {
        _obj.items[i].sortOrder = _obj.items[i].sortOrder - 1;
      }
    }
    setInventoryTypes({..._obj});
    setRenderIndex(renderIndex + 1);
  }

  return (
    <Modal onHide={handleClose} size={'lg'} show={props.show}>
      <form onSubmit={handleSubmit(handleSave)} id={'sortForm'}>
        <Modal.Header closeButton>
          <Modal.Title>Sort Inventory Types</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {inventoryTypes?.items?.length > 0 &&
            <Row>
              <Col className={'col col-main'} xs={12}>
                <Container>
                  {renderIndex && inventoryTypes?.items?.sort((a, b) => a.sortOrder - b.sortOrder).map((item, index) => {
                    return (
                      <ul className={'mt-2 list-group'} key={index + renderIndex}>
                        <li
                          className={'list-group-item'}>
                          {index !== 0 && <MDButton color="primary"
                                                    className="pull-right mx-1"
                                                    size="small"
                                                    onClick={() => {
                                                      moveUp(item);
                                                    }}>
                           <span
                             style={{
                               fontSize: '16px'
                             }}
                             className={'fa fa-arrow-circle-up'}></span>
                          </MDButton>
                          }
                          <MDTypography variant="h6" fontWeight="regular" pt={2}>
                            {item.name}
                          </MDTypography>
                          <br/> {item.desc}


                          {index !== inventoryTypes.items.length - 1 && <MDButton color="primary"
                                                                                  className="pull-right mx-1"
                                                                                  size="small"
                                                                                  onClick={() => {
                                                                                moveDown(item);
                                                                              }}>
                            <span
                              style={{
                                fontSize: '16px'
                              }}
                              className={'fa fa-arrow-circle-down'}></span>
                          </MDButton>
                          }
                        </li>
                      </ul>
                    )
                  })}

                </Container>
              </Col>
            </Row>
          }
        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={formInvalid || props.saving}>
            {props.saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}